import { FONT_FAMILY, THEME_COLORS } from "@common/themes";
import ToolTip from "@mui/material/Tooltip";
import React from "react";
import { View } from "react-native";

export const Tooltip = (props) => {
  const { text, img } = props;

  return (
    <ToolTip
      slotProps={{
        arrow: { sx: { color: THEME_COLORS.primary } },
        tooltip: {
          sx: {
            fontSize: "0.9rem",
            color: "white",
            fontFamily: FONT_FAMILY.four,
            background: `linear-gradient(to bottom, ${THEME_COLORS.primary} 100%, ${THEME_COLORS.bgWhite})`,
            padding: "0.8em 1.4em",
            borderRadius: 10,
          },
        },
      }}
      placement="top"
      title={text}
      arrow
      PopperProps={{
        popperOptions: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 10],
              },
            },
          ],
        },
      }}
    >
      <View style={{ justifyContent: "center", alignItems: "center", marginLeft: 5 }}>
        <img src={img} style={{ width: 12, height: 12 }} />
      </View>
    </ToolTip>
  );
};
